"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityExistsError = void 0;
var tslib_1 = require("tslib");
var PersistentError_1 = require("./PersistentError");
var EntityExistsError = /** @class */ (function (_super) {
    tslib_1.__extends(EntityExistsError, _super);
    /**
     * @param entity - The entity which cause the error
     */
    function EntityExistsError(entity) {
        var _this = _super.call(this, "The entity ".concat(entity, " is managed by a different db.")) || this;
        _this.entity = entity;
        return _this;
    }
    return EntityExistsError;
}(PersistentError_1.PersistentError));
exports.EntityExistsError = EntityExistsError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRW50aXR5RXhpc3RzRXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJFbnRpdHlFeGlzdHNFcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O0FBQUEscURBQW9EO0FBR3BEO0lBQXVDLDZDQUFlO0lBTXBEOztPQUVHO0lBQ0gsMkJBQVksTUFBYztRQUExQixZQUNFLGtCQUFNLHFCQUFjLE1BQU0sbUNBQWdDLENBQUMsU0FFNUQ7UUFEQyxLQUFJLENBQUMsTUFBTSxHQUFHLE1BQU0sQ0FBQzs7SUFDdkIsQ0FBQztJQUNILHdCQUFDO0FBQUQsQ0FBQyxBQWJELENBQXVDLGlDQUFlLEdBYXJEO0FBYlksOENBQWlCIn0=